import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class AuthorityManagerMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.authorityManager.authorityManagerMapperError"));

        Object.setPrototypeOf(this, AuthorityManagerMapperError.prototype);
    }
}